import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_1sahwzac: FaireBrandEntity = {
  token: "b_1sahwzac",
  type: "brand",
  name: "Hammerpress",
  avatarUrl:
    "https://cdn.faire.com/fastly/f40ef3caf7b01bf670fe9663f9810f075b39df2693b5dfcce6e2da8475c380e4.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/845fb0bb1db20f30197ab87ee242f3f01bce31dab709df2f2edf5c921ec7c62f.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/f40ef3caf7b01bf670fe9663f9810f075b39df2693b5dfcce6e2da8475c380e4.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/845fb0bb1db20f30197ab87ee242f3f01bce31dab709df2f2edf5c921ec7c62f.jpeg",
  location: " Kansas City, MO, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 76,
  isTopShop: true,
  isInsider: true,
  description:
    "Please message us if you have questions about ship dates and turnaround time! The estimated ship date on Faire is conservative and shipping may be much sooner.\n\nOwner Brady Vest established Hammerpress in 1994. Vest quickly earned recognition by creating distinctive record covers and show posters for independent bands and printing letterpress jobs for local design firms. Hammerpress has grown to a small team that produces lovely letterpress products and strives to continue the craft. Now one of the most widely known letterpress studios in the United States, Hammerpress has garnered much attention for our distinct approach to typography and design.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:55:54.647Z",
    importedBy: "entity-db-cli",
  },
};
